<template>
  <v-autocomplete
    v-bind="$attrs"
    :value="value"
    :disabled="loading"
    :loading="loading"
    :items="items"
    item-text="code"
    item-value="id"
    @change="select"
    return-object
  >
    <template v-slot:selection="data">
      {{ data.item.code.toUpperCase() }}
    </template>
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title
          v-html="data.item.code.toUpperCase()"
        ></v-list-item-title>
        <v-list-item-subtitle
          v-html="data.item.description"
        ></v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action-text v-if="data.item.rate"
        >{{ rateFactor(data.item.rate).toLocaleString("de-CH") }}
        {{ data.item.code.toUpperCase() }} =
        {{ (rateFactor(data.item.rate) / data.item.rate).toFixed(2) }} CHF
      </v-list-item-action-text>
    </template>
  </v-autocomplete>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CurrencyChoice",
  props: ["value"],
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  methods: {
    rateFactor(currencyRate) {
      return Math.pow(10, Number.parseInt(currencyRate).toString().length);
    },
    async getData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/currency",
      });
      this.loading = false;
    },
    remove() {
      this.$emit("input", null);
    },
    select($event) {
      this.$emit("input", $event);
    },
  },
  async created() {
    this.getData();
  },
});
</script>
